import { Trigger } from '@radix-ui/react-dialog'
import type { ComponentPropsWithoutRef } from 'react'

type TriggerProps = ComponentPropsWithoutRef<typeof Trigger>

export interface SheetTriggerProps extends TriggerProps {
  asChild?: TriggerProps['asChild']
  className?: TriggerProps['className']
}

export const SheetTrigger = Trigger
